import React from 'react';
import PropTypes from 'prop-types';
import shallowCompare from 'react-addons-shallow-compare';
import moment from 'moment';

import './CalendarMonthOption.scss';

export const TOUCHSTART_TIMEOUT = 200;

const propTypes = {
  tabIndex: PropTypes.oneOf([0, -1]),
  isFocused: PropTypes.bool,

  month: PropTypes.func,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  onMonthClick: PropTypes.func,
  onMonthMouseDown: PropTypes.func,
  onMonthMouseUp: PropTypes.func,
  onMonthMouseEnter: PropTypes.func,
  onMonthMouseLeave: PropTypes.func,
  onMonthTouchStart: PropTypes.func,
  onMonthTouchEnd: PropTypes.func,
  onMonthTouchTap: PropTypes.func,
};

const defaultProps = {
  tabIndex: -1,
  isFocused: false,

  month: () => moment(),
  modifiers: [],
  onMonthClick() {},
  onMonthMouseDown() {},
  onMonthMouseUp() {},
  onMonthMouseEnter() {},
  onMonthMouseLeave() {},
  onMonthTouchStart() {},
  onMonthTouchEnd() {},
  onMonthTouchTap() {},
};

export default class CalendarMonthOption extends React.Component {
  buttonRef = null;
  hasActiveTouchStart = false;
  timeout = void 0;

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  componentDidUpdate(prevProps) {
    const { isFocused, tabIndex } = this.props;
    if (tabIndex !== 0) {
      return;
    }

    if (isFocused || tabIndex !== prevProps.tabIndex) {
      this.buttonRef.focus();
    }
  }

  handleMonthClick(month, modifiers, e) {
    this.props.onMonthClick(month, modifiers, e);
  }

  handleMonthMouseDown(month, modifiers, e) {
    this.props.onMonthMouseDown(month, modifiers, e);
  }

  handleMonthMouseUp(month, modifiers, e) {
    this.props.onMonthMouseUp(month, modifiers, e);
  }

  handleMonthMouseEnter(month, modifiers, e) {
    this.props.onMonthMouseEnter(month, modifiers, e);
  }

  handleMonthMouseLeave(month, modifiers, e) {
    this.props.onMonthMouseLeave(month, modifiers, e);
  }

  handleMonthTouchStart(month, modifiers, e) {
    this.hasActiveTouchStart = true;
    this.timeout = setTimeout(() => {
      this.hasActiveTouchStart = false;
    }, TOUCHSTART_TIMEOUT);

    this.props.onMonthTouchStart(month, modifiers, e);
  }

  handleMonthTouchEnd(month, modifiers, e) {
    if (this.hasActiveTouchStart) {
      this.hasActiveTouchStart = false;
      this.handleMonthTouchTap(month, modifiers, e);
    }

    this.props.onMonthTouchEnd(month, modifiers, e);
  }

  handleMonthTouchTap(month, modifiers, e) {
    this.props.onMonthTouchTap(month, modifiers, e);
  }

  render() {
    const {
      month,
      modifiers,
      tabIndex
    } = this.props;

    return (
      <button ref={ref => this.buttonRef = ref}
              data-month={month().format('YYYY-MM')}
              className="CalendarMonthOption"
              onMouseEnter={e => this.handleMonthMouseEnter(month(), modifiers, e)}
              onMouseLeave={e => this.handleMonthMouseLeave(month(), modifiers, e)}
              onMouseDown={e => this.handleMonthMouseDown(month(), modifiers, e)}
              onMouseUp={e => this.handleMonthMouseUp(month(), modifiers, e)}
              onClick={e => this.handleMonthClick(month(), modifiers, e)}
              onTouchStart={e => this.handleMonthTouchStart(month(), modifiers, e)}
              onTouchEnd={e => this.handleMonthTouchEnd(month(), modifiers, e)}
              tabIndex={tabIndex}>
        {month().format('MMMM')}
      </button>
    );
  }
}

CalendarMonthOption.propTypes = propTypes;
CalendarMonthOption.defaultProps = defaultProps;
